/* eslint-disable react/prop-types */
import React from 'react';
import {StyleSheet, View} from 'react-native';
import Style from '../styles/customButton';
import CustomButton from './customButton';
import {responsiveWidth} from './customResponsiveDimension';
import LinearGradient from './gradient';
import Hoverable from './hover/hoverable';

const styles = StyleSheet.create({
  OrangeButtonStyle: {
    // marginTop: responsiveHeight(3)
  },
  OrangeButtonStyle_LAPTOP: {width: 155},
  OrangeButtonStyle_LDPI: {
    width: '100%',
    marginRight: responsiveWidth(0)
  },
  OrangeButtonStyle_HDPI: {
    width: '100%',
    marginRight: responsiveWidth(0)
  },
  OrangeButtonStyle_MDPI: {
    width: '100%',
    marginRight: responsiveWidth(0)
  },
  OrangeButtonStyle_XHDPI: {
    width: '100%',
    marginRight: responsiveWidth(0)
  },
  OrangeButtonStyle_XXHDPI: {
    width: '100%',
    marginRight: responsiveWidth(0)
  },
  OrangeButtonStyle_XXXHDPI: {width: '100%'}
});

export default function CustomLinearOrangeButton(props) {
  const {style, containerStyle, commonLinearOrangeGradientButtonContainerStyle,hoverStyle, hoverColor, colors, ...others} = props;

  return (
    <View>
      <Hoverable>
        {isHovered => (
          <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}} colors={isHovered ? hoverColor || ['#E17019e6', '#D15A20e6', '#C14427e6'] : colors || ['#E17019', '#D15A20', '#C14427']} style={[containerStyle, commonLinearOrangeGradientButtonContainerStyle || Style.commonLinearOrangeGradientButtonContainerStyle]}>
            <CustomButton style={[Style.commonButtonTextStyle, Style.darkBlueButtonTextStyle, style]} containerStyle={[containerStyle, Style.commonLinearButtonContainerStyle]} nativeID={props.nativeID} hoverStyle={{backgroundColor: 'transparent'}} {...others}></CustomButton>
          </LinearGradient>
        )}
      </Hoverable>
    </View>
  );
}
